import React, { useState } from 'react';
import { DropdownComponent, InputComponent } from '../core/Forms';
import { parsePhoneNumber } from 'libphonenumber-js';
import { INDUSTRIES, SIZES } from '../../constants/industries';
import 'react-phone-number-input/style.css';
import PhoneInput, { formatPhoneNumber } from 'react-phone-number-input';
import { clearFieldError } from '../../utils/handleErrors';
import { validateInfoForm } from '../../modules/auth/register';
import LocationSelector from '../common/Address';
import { ICreateProfile, IProfile, IUpdateProfile } from '../../@types';

interface FormData {
  [key: string]: string;
  firstName: string;
  lastName: string;
  businessSize: string;
  industry: string;
  phone: string;
  address: string;
  state: string;
  city: string;
}

interface ValidationResults {
  firstName: string;
  lastName: string;
  businessSize: string;
  industry: string;
  phone: string;
  address: string;
  state: string;
  city: string;
  [key: string]: string;
}

interface BusinessInfoStepProps {
  setActiveStep: (step: number) => void;
  profile?: IProfile;
  handleUpdateProfile: (profile: IUpdateProfile) => Promise<void>;
}

const BusinessInfoStep: React.FC<BusinessInfoStepProps> = (props) => {
  const { profile, setActiveStep } = props;
  const [value, setValue] = useState('');
  const initialPhoneNumber = '+234';
  const dropDownArray = INDUSTRIES;
  const BusinessdropDownArray = SIZES;
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedValue2, setSelectedValue2] = useState('');
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [placeholder] = useState('+234 900 000 0000');
  const [state, setState] = React.useState(profile?.state || '');
  const [city, setCity] = React.useState(profile?.city || '');
  const [isLoading, setIsLoading] = useState(false); 
  const [error, setError] = useState<string | null>(null);
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    lastName: '',
    businessSize: '',
    industry: '',
    phone: '',
    address: '',
    state: '',
    city: '',
  });
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    businessSize: '',
    industry: '',
    phone: '',
    address: '',
    state: '',
    city: '',
  });

  const [validationResults, setValidationResults] = useState<ValidationResults>({
    firstName: '',
    lastName: '',
    businessSize: '',
    industry: '',
    phone: '',
    address: '',
    state: '',
    city: '',
  });

  const phoneNumber = '+2340000000000';

  const handlePhoneNumberChange = (value: string) => {
    if (value) {
      const trimmedValue = value.trim();
  
      if (trimmedValue.length === 14) {
        const formattedNumber = `${trimmedValue.substring(1)}`;
        setFormData({ ...formData, phone: formattedNumber });
        setValidationResults({ ...validationResults, phone: '' });
        setValue(formattedNumber);
      } else {
        setValidationResults({
          ...validationResults,
          phone: 'Please enter a valid Nigerian phone number',
        });
      }
    } else {
      setValue('');
      setFormData({ ...formData, phone: '' });
      setValidationResults({ ...validationResults, phone: '' });
    }
  };

  

  const handlePhoneNumberKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.currentTarget.value.length >= 17) {
      event.preventDefault();
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    const errors = validateInfoForm(name, value, formData, validationResults);
    setValidationResults(errors);
    clearFieldError(name, validationResults, setValidationResults);
  };

  const handleDropDownChange = (name: string, selectedValue: string) => {
    console.log(`Selected value: ${selectedValue}`);
    setFormData({ ...formData, industry: selectedValue });
    clearFieldError(name, validationResults, setValidationResults);
  };

  const handleDropDownChange2 = (name: string, selectedValue2: string) => {
    console.log(`Selected value: ${selectedValue2}`);
    setFormData({ ...formData, businessSize: selectedValue2 });
    clearFieldError(name, validationResults, setValidationResults);
  };
  const handleLocationChange = (selectedState: string, cities: string | any[]) => {
    setState(selectedState);
    setCity(cities.length > 0 ? cities[0] : '');

    setFormData((prevData: any) => ({
      ...prevData,
      state: selectedState,
      city: cities.length > 0 ? cities[0] : '',
    }));
  };

  const handlePrevious = () => {
    //@ts-ignore
    setActiveStep((prev: number) => prev - 1);
  };
  const handleNext = async () => {
    let hasErrors = false;
    const updatedValidationResults = { ...validationResults };
    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      const error = validateInfoForm(key, value, formData, validationResults)[key];
      updatedValidationResults[key] = error;

      console.log(`Field: ${key}, Value: ${value}, Error: ${error}`);
      if (value.trim() === '' || error !== '') {
        hasErrors = true;
      }
    });

    console.log('Has errors:', hasErrors);
    console.log('Validation results:', updatedValidationResults);

    setValidationResults(updatedValidationResults);

    if (hasErrors) {
      setIsSubmitted(true);
    } else {
      setIsLoading(true);
      const newProfileData = { ...formData };
      try {
        await props.handleUpdateProfile(newProfileData);
        //@ts-ignore
        setActiveStep((prev) => prev + 1);
      } catch (err) {
        const errorMessage = err as Error; 
        setError(errorMessage.message); 
      } finally {
        setIsLoading(false);
      }
    }
  }

  return (
    <div className="flex flex-col justify-center">
      <div className="xl:ml-[16.4em] mt-[6em] 414:ml-[1em] 412:ml-[1.2em] 540:ml-[4em] biglg:ml-[9.3em] md:ml-[0.6em] bigmd:ml-[2em] lg:ml-[4em] 2xl:ml-[18.6em] 3xl:ml-[22.5em] ">
        <h2 className="g:text-[24px] text-[20px] md:text-[24px] bigmd:text-[24px] text-[#292D32] font-bold">
          Fill In Your Business Details
        </h2>
        <p className="mb-4 lg:text-[16px] font-light text-[14px] md:text-[16px] bigmd:text-[16px]">
          Fill in your business details to get started
        </p>
      </div>
      <form>
        <div className="flex flex-col justify-center ml-[0.3em] 375:ml-[-0.3em] 414:ml-[1em] 360:ml-[-0.7em] 412:ml-[1.2em] 540:ml-[4em] md:ml-[0.6em] lg:ml-[1.3em] biglg:ml-[7em] bigmd:ml-[2em]">
          <div className=" md:mt-[2em] md:ml-[-0.2em] lg:ml-[2em] xl:flex xl:justify-center xl:gap-[5px] xl:placeholder:text-[13.25px] xl:h-[48px] xl:rounded xl:mt-[10px] xl:ml-[-2.9em] 2xl:ml-[-3em] ">
            <div className="mt-[1em] md:w-[434px] xl:w-[215px]">
              <label
                htmlFor=" First Name"
                className=" text-[12px] md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black "
              >
                First Name
              </label>
              <InputComponent
                placeholder="First Name"
                name="firstName"
                type="text"
                value={formData.firstName}
                handleChange={handleInputChange}
                error={validationResults.firstName}
                className="w-[350px] rounded-md xl:w-[215px] md:w-[434px]"
              />
            </div>
            <div className="mt-[1em] md:w-[434px] w-full xl:w-[215px]  ">
              <label
                htmlFor="Last Name"
                className=" text-[12px] md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black "
              >
                Last Name
              </label>
              <InputComponent
                placeholder="Last Name"
                name="lastName"
                type="text"
                value={formData.lastName}
                handleChange={handleInputChange}
                error={validationResults.lastName}
                className=" w-[350px] rounded-md md:w-[434px] xl:w-[215px]"
              />
            </div>
          </div>

          <div className="border-gray-300 mt-[1em]  md:ml-[-0.3em] lg:ml-[2em] lg:pr-[1em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px]  xl:rounded xl:ml-[-2em] 2xl:ml-[-2em]">
            <div className=" border-gray-300 md:w-[434px] xl:w-[434px] xl:pr-[15px] xl:py-[37px] w-[350px] ">
              <label
                htmlFor="Select Industry"
                className=" text-[11px] font-sm block p-1 md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black "
              >
                Select Industry
              </label>
              <DropdownComponent
                options={dropDownArray}
                error={validationResults.industry}
                placeholder="Select Industry"
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                onChange={handleDropDownChange}
                isSubmitted={isSubmitted}
                dropdownClassName=" w-[350px] border-gray-300 rounded-md placeholder-gray-400 placeholder-opacity-75 md:w-[434px]  xl:w-[434px] bg-white  rounded py-1 focus:ring-0 pointer-events placeholder-gray-400 placeholder-opacity-75"
                iconClassName="mr-[1em] mt-[-0.2em]  md:mr-[1em] md:mt-[-0.2em] lg:mr-[1em] lg:mt-[0.2em] xl:mt-[px] xl:mr-[0.5em] "
              />
            </div>
          </div>
          <div className="border-gray-300 mt-[1em]  md:ml-[-0.3em]  lg:ml-[2em] lg:pr-[1em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px]  xl:rounded xl:mt-[40px] xl:ml-[-2em] 2xl:ml-[-2em] ">
            <div className=" border-gray-300 md:w-[434px] xl:w-[434px] xl:pr-[15px] xl:py-[37px] w-[350px]  ">
              <label
                htmlFor="Select Industry"
                className=" text-[11px] font-sm block p-1 md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black "
              >
                Business Size
              </label>
              <DropdownComponent
                options={BusinessdropDownArray}
                error={validationResults.businessSize}
                placeholder="Business Size"
                selectedValue={selectedValue2}
                setSelectedValue={setSelectedValue2}
                onChange={handleDropDownChange2}
                isSubmitted={isSubmitted}
                dropdownClassName=" w-[350px]  border-gray-300 rounded-md p-2 xl:p-2 placeholder-gray-400 placeholder-opacity-75 md:w-[434px]  xl:w-[434px] xl:bg-white  xl:rounded xl:py-1 xl:focus:ring-0 xl:pointer-events xl:placeholder-gray-400 xl:placeholder-opacity-75"
                iconClassName="mr-[1em] mt-[-0.2em]  md:mr-[1em] md:mt-[-0.2em] lg:mr-[1em] lg:mt-[0.2em] xl:mt-[px] xl:mr-[0.5em] "
              />
            </div>
          </div>

          <div className="mt-[1em]  md:ml-[-0.3em] lg:ml-[2em] xl:mt-[5em] xl:ml-[15em] 2xl:ml-[17.5em] 3xl:ml-[21.5em] ">
            <label
              htmlFor="Phone Number"
              className="text-[11px] md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black  "
            >
              Business WhatsApp Number
            </label>
          </div>

          <div className="w-[350px] md:w-[434px] md:ml-[-0.3em] lg:ml-[2em] xl:w-[434px] 2xl:w-[434px]  xl:ml-[14.8em] 2xl:ml-[17em] 3xl:ml-[21.5em] ">
            <PhoneInput
              placeholder={placeholder}
              limitMaxLength={true}
              defaultCountry="NG"
              value={formData.phone}            
              onChange={handlePhoneNumberChange}
              className="react-phone-number-input"
              inputClassName="react-phone-number-input__input"
              onKeyDown={handlePhoneNumberKeyDown}
              maxLength={20}
              countries={['NG']}
            />
          </div>

          <div className="relative ml-[0.1em] md:ml-[0.1em] lg:ml-[1.8em] xl:ml-[15em] 2xl:ml-[17em] 3xl:ml-[22em]  ">
            {validationResults.phone && validationResults.phone.length > 0 && ( 
<p className="text-red-500 text-sm">{validationResults.phone}</p> 
)}

          </div>

          <div className=" mt-[1em]  md:ml-[-0.3em] lg:ml-[2em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px]  xl:rounded  xl:mt-[-1.5em] xl:ml-[-2.5em] 2xl:ml-[-3em] ">
            <div className=" xl:w-[434px] md:w-[434px] xl:pr-[15px] xl:py-[37px]">
              <label
                htmlFor="address"
                className=" text-[11px] md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black "
              >
                Address
              </label>
              <InputComponent
                placeholder="Address"
                name="address"
                type="text"
                value={formData.address}
                handleChange={handleInputChange}
                error={validationResults.address}
                className="xl:w-[434px] w-[350px] rounded-md md:w-[434px]"
              />
            </div>
          </div>
          <div className="w-[350px]  mt-[1em]  md:w-[434px] xl:w-[434px] xl:mt-[1em]  md:ml-[-0.3em]  lg:ml-[2em] placeholder:text-[16px] h-[48px] rounded xl:ml-[15em] 2xl:ml-[17em] 3xl:ml-[21.5em]  ">
            <LocationSelector
              onLocationChange={handleLocationChange}
              onError={(error: any) => {}}
              selectedState={state}
              selectedCity={city}
            />
          </div>
        </div>
      </form>

      <div className="flex  xl:gap-[2.5em] xl:ml-[16em] 2xl:ml-[18.8em] xl:mt:-[6em] ml-[-0.1em] gap-[1em] md:gap-[2em] 414:ml-[1em] mt-[6em] 412:ml-[1.2em] 540:ml-[4em] biglg:ml-[9em] lg:ml-[4em] lg:mt-[11em] biglg:mt-[11em] md:ml-[0.6em] bigmd:ml-[2em] 3xl:ml-[21.5em] ">
        <button
          className="bg-[#ffffff] text-[16px]  h-[48px]  w-[165px] #044E97focus:ring-[#044E97] rounded-md text-[#044E97] ml:[2em] md:mr-[-1.5em] mt-[2.7em] md:mt-[2.9em] xl:mt-[2em] md:w-[200px] lg:mr-[-0.5em]  lg:mt-[-2em] xl:w-[200px] xl:mr-[-0.5em] mb-[2em]"
          onClick={handlePrevious}
        >
          Previous Step
        </button>
        <button
          className="bg-[#044E97] text-[16px]  h-[48px] 540:mr-[5em] w-[165px]  rounded-md text-[#ffffff] ml:[2em] md:mr-[-1.5em] mt-[2.7em] md:mt-[2.9em] xl:mt-[2em] md:w-[200px] lg:mr-[-0.5em]  lg:mt-[-2em] xl:w-[200px] xl:mr-[-0.5em] mb-[2em]"
          onClick={handleNext}
          disabled={isLoading} 
        >
         {isLoading ? 'Loading...' : 'Next Step'} 
        </button>
      </div>
    </div>
  );
};

export default BusinessInfoStep;
